import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { environment } from '@base/environments/environment';
import { Subscription } from 'rxjs';
import { Constants } from '../../models/constants';
import { NodeId } from './if-node-hide.directive';

export type { NodeId } from './if-node-hide.directive';
@Directive({
  selector: '[ifNodeShow]', // uso: *ifNode="['ar','ec']"
})
export class IfNodeShowDirective implements OnInit, OnDestroy {
  @Input('ifNodeShow') allowedNodes: NodeId[] = [];
  algo = Constants;
  NODE = environment.node;
  private hasView = false;
  private sub?: Subscription;
  constructor(private tpl: TemplateRef<any>, private vcr: ViewContainerRef) {}
  ngOnInit(): void {
    this.render();
  }
  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
  private render(): void {
    const CAN_SHOW: boolean =
      Array.isArray(this.allowedNodes) && this.allowedNodes.includes(this.NODE);
    if (CAN_SHOW && !this.hasView) {
      this.vcr.clear();
      this.vcr.createEmbeddedView(this.tpl);
      this.hasView = true;
    } else if (!CAN_SHOW && this.hasView) {
      this.vcr.clear();
      this.hasView = false;
    }
  }
}
